export const footer = `
<footer id="footer" class="site-footer" role="contentinfo">
	<div class="container">

		<div class="top">
			<a href="https://www.massbio.org" class="footer-logo"></a>
		</div>

		<div class="bottom">
			<div class="address-social">
				<p class="title">Massachusetts Biotechnology Council</p>
				<p>700 Technology Square, 5th Floor<br/>
					Cambridge, MA 02139<br/>
					617.674.5100<br/></p>

				<div class="social">
					<a href="https://www.facebook.com/massbio" class="facebook external"
					   title="Like us on Facebook" target="_blank">
						<i class="icon icon-facebook"></i>
					</a>
					<a href="https://www.twitter.com/MassBio" class="twitter external"
					   title="Follow us on Twitter" target="_blank">
						<i class="icon icon-twitter"></i>
					</a>
					<a href="https://www.linkedin.com/groups/65240/profile" class="linkedin external"
					   title="Connect with us on LinkedIn" target="_blank">
						<i class="icon icon-linkedin"></i>
					</a>
					<a href="https://www.youtube.com/user/MassBio" class="youtube external"
					   title="Watch us on YouTube" target="_blank">
						<i class="icon icon-youtube-play"></i>
					</a>
				</div>
			</div>
			<div class="search-links">
				<div class="form-holder">

					<form role="search" method="get" class="search-form" action="/"
						  data-dashlane-rid="0ce82b522b440586" data-form-type="">
						<label data-dashlane-label="true">
							<span class="screen-reader-text">Search for:</span>
							<input type="search" class="search-field" value="" name="s"
								   data-dashlane-rid="3167c5d8c4bc9379" data-form-type=""/>
						</label>
						<button type="submit" class="search-submit" data-dashlane-rid="db3c1c4192cfba20"
								data-form-type="" data-dashlane-label="true">
							<span class="screen-reader-text">Search</span><i class="icon icon-search"></i>
						</button>
					</form>
				</div>
				<ul class="footer-menu">
					<li id="menu-item-2010"
						class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2010"><a
							href="https://www.massbio.org/contact/">Contact</a></li>
					<li id="menu-item-2009"
						class="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-2009">
						<a href="https://www.massbio.org/privacy-policy/">Privacy Policy</a></li>
					<li id="menu-item-65951"
						class="menu-item menu-item-type-post_type menu-item-object-page menu-item-65951"><a
							href="https://www.massbio.org/order-and-refund-policy/">Fulfillment Policy</a></li>
					<li>© 2021 All Rights Reserved</li>
				</ul>
			</div>
		</div>

	</div>
</footer>
`

export default footer;
